
/**
 * 仿 $.params
 * @param {object} o
 */
function params(param) {
  if(!param) {
    return '';
  }

  const ret = [];
  for(let k in param) {
    if (param.hasOwnProperty(k)) {
      ret.push(k + '=' + encodeURIComponent(param[k]));
    }
  }
  return ret.join('&');
}

// 返回随机字符串
function makeid(length) {
  let text = "";
  const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (let i = 0; i < length; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));

  return text;
}

const loadJSONP = (function () {
  return function (url, param, callback, context) {
    if (typeof param === 'object') {
      url = [url, params(param)].join('?');
    } else {
      context = callback;
      callback = param;
    }

    // INIT
    const name = "_jsonp_" + makeid(5);
    if (url.match(/\?/)) url += "&callback=" + name;
    else url += "?callback=" + name;

    // Create script
    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;

    // Setup handler
    window[name] = function (data) {
      callback.call((context || window), data);
      document.getElementsByTagName('head')[0].removeChild(script);
      script = null;
      delete window[name];
    };

    // Load JSON
    document.getElementsByTagName('head')[0].appendChild(script);
  };
})();

export default {
  loadJSONP
};
